<template>
  <div class="container">
    <el-row style="margin: 50px 0 50px" :gutter="40">
      <!-- The information about us -->
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>About Us</span>
          </div>
          <div class="text item">
            <i class="el-icon-location"></i>&nbsp;<b>Location</b>
            <p>Computer building #410, 932 Lushan S Rd, Yuelu District, Changsha, Hunan, China</p>
          </div>
          <el-divider></el-divider>
          <div class="text item">
            <i class="el-icon-phone"></i>&nbsp;<b>Telephone</b>
            <p>+86-0731-88879560</p>
          </div>
          <el-divider></el-divider>
          <div class="text item">
            <i class="el-icon-message"></i>&nbsp;<b>E-mail</b>
            <p>limin@mail.csu.edu.cn</p>
          </div>
        </el-card>
      </el-col>
      <!-- message form -->
      <el-col :span="18" >
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            Leave us a message!
          </div>
          <p>If you have any questions/suggestions or if you want to integrate your method into PGMG, please fill in the form below, and we will reply you as soon as possible. We look forward to hearing from you!
          </p>
          <el-form :label-position="labelPosition" label-width="110px" :model="messageForm" ref="messageForm" :rules="rules" style="text-align: center">
            <el-form-item label="First Name">
              <el-input v-model="messageForm.firstName" placeholder="First Name"></el-input>
            </el-form-item>
            <el-form-item label="LastName">
              <el-input v-model="messageForm.lastName" placeholder="Last Name"></el-input>
            </el-form-item>
            <el-form-item label="E-mail" prop="email">
              <el-input v-model="messageForm.email" placeholder="E-mail"></el-input>
            </el-form-item>
            <el-form-item label="Message" prop="message">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="Message"
                  v-model="messageForm.message">
              </el-input>
            </el-form-item>
            <el-button type="primary" @click="submit">Send</el-button>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      labelPosition: 'left',
      rules: {
        email: [
          {required: true, message: 'Please input the email address.', trigger: 'blur'},
          {type: 'email', message: 'Please input the correct email address'}
        ],
        message: [
          {required: true, message: 'Please input the message.', trigger: 'blur'}
        ]
      },
      messageForm: {
        firstName: '',
        lastName: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs['messageForm'].validate((valid) => {
        if (valid) {
          console.log('submit');
          const formData = new FormData();
          formData.append('firstName', this.messageForm.firstName);
          formData.append('lastName', this.messageForm.lastName);
          formData.append('email', this.messageForm.email);
          formData.append('message', this.messageForm.message);
          // TODO: change url
          axios.post('/contact', formData).then( res => {
            console.log(res.data);
            this.$alert('Send successfully!');
          }).catch(err => {
            console.log(err);
            this.$alert('error submit!!')
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.container {
  width: 85%;
  margin: 0 auto;
}

.box-card {
  text-align: left;
}

.box-card  p {
  color: #6c757d;
  font-size: 15px;
  line-height: 25px;
}

</style>
